"use client";

import { spacing } from "@softmax/design-system/tokens.stylex";

import type {
  EpisodeTableRow,
  EpisodeSort,
  EpisodeFilter,
  EpisodeFilterOption,
} from "./episode-values";
import * as stylex from "@stylexjs/stylex";
import { styles } from "./episodes.styles";
import { ToggleButton } from "@softmax/design-system";
import { SortSelect } from "./episode-sort-select";
import { EpisodeRows } from "./episode-rows";

type EpisodesTableProps = {
  readonly rows: readonly EpisodeTableRow[];
  readonly filters: readonly EpisodeFilterOption[];
  readonly activeFilter: EpisodeFilter;
  readonly sort: EpisodeSort;
  readonly onFilterChange: (filter: EpisodeFilter) => void;
  readonly onSortChange: (sort: EpisodeSort) => void;
  readonly footer: string;
  readonly allEpisodesHref: string | null;
};

export function EpisodesTable({
  rows,
  filters,
  activeFilter,
  sort,
  onFilterChange,
  onSortChange,
  footer,
  allEpisodesHref,
}: EpisodesTableProps) {
  return (
    <div {...stylex.props(styles.root)}>
      <div {...stylex.props(localStyles.toolbar)}>
        <div {...stylex.props(localStyles.filters)}>
          {filters.map((option) => (
            <ToggleButton
              key={option.key}
              size="sm"
              pressed={activeFilter === option.key}
              onPressedChange={() => onFilterChange(option.key)}
            >
              {option.label}
            </ToggleButton>
          ))}
        </div>
        <SortSelect sort={sort} onChange={onSortChange} />
      </div>
      <EpisodeRows rows={rows} kind="member" />
      <div {...stylex.props(styles.foot)}>
        <span>{footer}</span>
        {allEpisodesHref ? (
          <a href={allEpisodesHref} {...stylex.props(styles.more)}>
            All episodes ›
          </a>
        ) : null}
      </div>
    </div>
  );
}

const localStyles = stylex.create({
  toolbar: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    gap: spacing.space16,
  },
  filters: { display: "flex", flexWrap: "wrap", gap: spacing.space8 },
});
